import soundFile from '../assets/sounds/slow-spring-board.mp3';

export function notificationPlay() {
    console.log('soundFile',soundFile);
    const audio = new Audio(soundFile);
    audio.play();
}